import { render, staticRenderFns } from "./MenteeTasks.vue?vue&type=template&id=612c276a"
import script from "./MenteeTasks.vue?vue&type=script&lang=js"
export * from "./MenteeTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports